import {
  computed,
  IObservableArray,
  makeAutoObservable,
  observable,
} from "mobx";
import Fuse from "fuse.js";
import { ModuleResponseApi } from "../../DTO/ServerResponseType/Module/Module";
import ModuleServerClient from "../../ServerClients/ModuleServerClient";

const fuseOptions = {
  isCaseSensitive: false,
  shouldSort: false,
};

let fuseName: Fuse<ModuleResponseApi> = new Fuse([], {
  ...fuseOptions,
  keys: ["moduleName"],
});

export class ModulesStore {
  public modules: IObservableArray<ModuleResponseApi> = observable.array([]);
  public searchPattern: string = "";

  constructor() {
    makeAutoObservable(this);
  }

  public setModules = (modules: ModuleResponseApi[]) => {
    this.searchPattern = "";
    this.modules.replace(modules);
  };

  public onChangeSearchPattern = (searchPattern: string) => {
    this.searchPattern = searchPattern;
  };

  @computed get searchedModules(): ModuleResponseApi[] {
    let newModules: ModuleResponseApi[] = this.modules.slice();

    // searched
    if (this.searchPattern !== "") {
      fuseName.setCollection(newModules);
      newModules = fuseName.search(this.searchPattern).map(({ item }) => item);
    }

    return newModules ? newModules : [];
  }

  public loadAllModulesAsync = async (): Promise<
    ModuleResponseApi[] | never
  > => {
    return ModuleServerClient.sendToGetAllModulesAsync().then((modules) => {
      this.setModules(modules);
      return modules;
    });
  };
}
